import React, {useEffect, useState} from 'react';
import img1 from '../images/image1.png';
import img2 from '../images/image2.png';
import img3 from '../images/image3.png';
import img4 from '../images/image4.png';
import img5 from '../images/image5.png';
import img6 from '../images/image6.png';
import img7 from '../images/image7.png';
import img8 from '../images/image8.png';
import img9 from '../images/image9.png';
import img10 from '../images/image10.png';
import img11 from '../images/image11.jpg';
import img12 from '../images/image12.png';
import img13 from '../images/image13.png';
import img14 from '../images/image14.png';
import img15 from '../images/image15.png';
import img16 from '../images/image16.png';
import img17 from '../images/image17.png';
import img18 from '../images/image18.png';
import img19 from '../images/image19.png';
import img20 from '../images/image20.png';
import img21 from '../images/image21.png';
import img22 from '../images/image22.png';
import img23 from '../images/image23.png';
import img24 from '../images/image24.png';
import img25 from '../images/image25.png';
import img26 from '../images/image26.png';
import img27 from '../images/image27.png';
import img28 from '../images/image28.jpg';
import img29 from '../images/image29.jpg';
import img30 from '../images/image30.jpg';
import img31 from '../images/image31.jpg';
import img32 from '../images/image32.jpg';
import img33 from '../images/image33.jpg';
import img34 from '../images/image34.jpg';
import img35 from '../images/image35.png';
import img36 from '../images/image36.png';
import img37 from '../images/image37.png';
import img38 from '../images/image38.png';
import img39 from '../images/image39.png';
import img40 from '../images/image40.png';
import 'aos/dist/aos.css'; // import AOS CSS
import AOS from 'aos';
import Footer from '../Footer';
import './Alumnimeet.css';

const Alumnimeet = () => {
  const [showScroll, setShowScroll] = useState(false);

  // Show button when scroll position is > 200px
  const checkScrollPosition = () => {
    if (window.scrollY > 200) {
      setShowScroll(true);  // Show the button
    } else {
      setShowScroll(false); // Hide the button
    }
  };

  // Scroll to top function
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  useEffect(() => {
    window.addEventListener("scroll", checkScrollPosition);
    return () => {
      window.removeEventListener("scroll", checkScrollPosition);
    };
  }, []);
  useEffect(() => {
    AOS.init({
      duration: 1000, // duration of the animation
    });
  }, []);

  return (
    <div>
      <p style={{ textAlign: 'justify', marginRight: "25px", fontSize: '1.2rem', marginBottom: '30px' , fontFamily: 'Tahoma', marginLeft: "25px", marginTop:'30px'}}>
      The primary purpose of TISSAA is to actively engage Alums by building and expanding a robust network. 
        The association organizes Alums meets, forms and promotes Special Interest Groups (SIGs) that cater to 
        the diverse backgrounds and professions of its members, and highlights the success stories of Alums. 
        TISSAA also undertakes various initiatives addressing causes of local, national, and international 
        importance, such as emergency response efforts, thereby contributing to the broader community and 
        fostering a sense of collective responsibility among its members.
      </p>
      <button
            className="scroll-to-top"
            onClick={scrollToTop}
          >
            ↑ Top
          </button>

      <h1 style={{ textAlign: 'left', margin: '20px 0', fontSize: '1.7rem', fontFamily: 'Inter', marginLeft:'25px'}}>Alums Meet</h1>
      <p style={{ textAlign: 'justify', marginRight: "35px", fontSize: '1.2rem', marginBottom: '30px' , fontFamily: 'Tahoma', marginLeft: "25px"}}>
        TISSAA organizes regional meetups combining workshops, panel discussions, and cultural activities. 
        Alums can register on the portal for ongoing engagement. The network comprises 35 groups, each managed 
        by an admin, with quarterly meetups coordinated by a chief admin. Events are documented and shared on 
        the website and social media to keep the community connected.
      </p>
      <hr style={{ border: '1px solid #ccc', margin: '30px 0' }} />
      
      <h2 style={{ textAlign: 'center', fontSize: '1.5rem', marginBottom: '20px' , fontFamily: 'Inter', marginLeft: "25px"}}>Jharkhand</h2>
      <p style={{ textAlign: 'justify', marginRight: "25px",fontSize: '1.2rem', marginBottom: '30px', fontFamily: 'Tahoma' , marginLeft: "25px"}}>
        On July 14, 2024, the TISS Alums Association Jharkhand Chapter hosted a vibrant Alums meet at The Sailors 
        Knot in Ranchi, bringing together more than 45 Alums from diverse TISS campuses and professional backgrounds. 
        The event was a great success in fostering connections, celebrating shared journeys, and setting the stage for 
        future collaborations. Key outcomes included plans to engage Alums at the district and state levels, encourage 
        outreach to aspiring TISS candidates, and initiate upskilling opportunities. Special thanks were given to 
        Pradeep Gupta and Amitabh Mehrotra for their invaluable efforts in organizing this memorable gathering.
      </p>
      <hr style={{ border: '1px solid #ccc', margin: '30px 0' }} />

      <div style={styles.scrollingContainer}>
        <div style={styles.scrollingContent}>
        <img src={img1} alt="Alumni Meet 1" style={{ ...styles.image, height: '270px' }} />
        <img src={img2} alt="Alumni Meet 2" style={{ ...styles.image, height: '270px' }} />
        <img src={img3} alt="Alumni Meet 3"  style={{ ...styles.image, height: '270px' }} />
        <img src={img4} alt="Alumni Meet 4" style={{ ...styles.image, height: '270px' }} />

        <img src={img1} alt="Alumni Meet 1" style={{ ...styles.image, height: '270px' }} />
        <img src={img2} alt="Alumni Meet 2" style={{ ...styles.image, height: '270px' }} />
        <img src={img3} alt="Alumni Meet 3"  style={{ ...styles.image, height: '270px' }} />
        <img src={img4} alt="Alumni Meet 4" style={{ ...styles.image, height: '270px' }} />
      </div></div>
      <hr style={{ border: '1px solid #ccc', margin: '30px 0' }} />

      <h2 style={{ textAlign: 'center', fontSize: '1.5rem', marginBottom: '20px' , fontFamily: 'Inter' , marginLeft: "25px"}}>Madhya Pradesh & Chhattisgarh</h2>
      <p style={{ textAlign: 'justify', marginRight: "25px",fontSize: '1.2rem', marginBottom: '30px' , fontFamily: 'Tahoma', marginLeft: "25px"}}>
      On September 24, 2023, TISSAA hosted an Alums reunion for Madhya Pradesh and Chhattisgarh in Bhopal,
       which saw the participation of 34 Alums. The event included a mix of engaging activities like interactive 
       introductions and the "Coin Game," followed by insightful discussions led by Alums such as Vaishali Gajbhiye and 
       Pankaj Singh. The focus was on strengthening TISSAA’s mission to enhance Alums connections, and attendees expressed 
       enthusiasm for regular quarterly gatherings. Special thanks to Ashish Bansal, Shobha Tirkey, and Siddharth Raghuwanshi 
       for their contributions to the event's success.
      </p>
      <div style={styles.scrollingContainer}>
        <div style={styles.scrollingContent}>
        <img src={img5} alt="Alumni Meet 1" style={{ ...styles.image, height: '270px' }} />
        <img src={img6} alt="Alumni Meet 1" style={{ ...styles.image, height: '270px' }} />
        <img src={img7} alt="Alumni Meet 1" style={{ ...styles.image, height: '270px' }} />

        <img src={img5} alt="Alumni Meet 1" style={{ ...styles.image, height: '270px' }} />
        <img src={img6} alt="Alumni Meet 1" style={{ ...styles.image, height: '270px' }} />
        <img src={img7} alt="Alumni Meet 1" style={{ ...styles.image, height: '270px' }} />
      </div></div>
      <hr style={{ border: '1px solid #ccc', margin: '30px 0' }} />

      <h2 style={{ textAlign: 'center', fontSize: '1.5rem', marginBottom: '20px' , fontFamily: 'Inter', marginLeft: "25px"}}>Andhra Pradesh & Telangana</h2>
      <p style={{ textAlign: 'justify', marginRight: "25px",fontSize: '1.2rem', marginBottom: '30px' , fontFamily: 'Tahoma', marginLeft: "25px"}}>
      TISSAA successfully hosted the Telangana and Andhra Pradesh Chapter Alums Meet on August 27,
       2023, in Hyderabad, attracting over 90 Alums spanning decades of TISS batches. This vibrant 
       gathering highlighted the importance of Alums networking and featured heartfelt interactions 
       among the attendees. The organizing committee, with the help of student volunteers, ensured 
       that the event was engaging and inspiring. The Hyderabad meet serves as a reminder of the
       lifelong connections formed at TISS and sets the tone for future Alums engagements.
      </p>
      <div style={styles.scrollingContainer}>
        <div style={styles.scrollingContent}>
        <img src={img9} alt="Alumni Meet 1" style={{ ...styles.image, height: '270px' }} />
        <img src={img8} alt="Alumni Meet 1" style={{ ...styles.image, height: '270px' }} />
        <img src={img10} alt="Alumni Meet 1" style={{ ...styles.image, height: '270px' }} />

        <img src={img9} alt="Alumni Meet 1" style={{ ...styles.image, height: '270px' }} />
        <img src={img8} alt="Alumni Meet 1" style={{ ...styles.image, height: '270px' }} />
        <img src={img10} alt="Alumni Meet 1" style={{ ...styles.image, height: '270px' }} />

        <img src={img9} alt="Alumni Meet 1" style={{ ...styles.image, height: '270px' }} />
        <img src={img8} alt="Alumni Meet 1" style={{ ...styles.image, height: '270px' }} />
      </div></div>

      <hr style={{ border: '1px solid #ccc', margin: '30px 0' }} />

      <h2 style={{ textAlign: 'center', fontSize: '1.5rem', marginBottom: '20px' , fontFamily: 'Inter', marginLeft : "15px"}}>Uttar Pradesh</h2>
      <p style={{textAlign: 'justify', marginRight: "25px", fontSize: '1.2rem', marginBottom: '30px' , fontFamily: 'Tahoma', marginLeft : "15px"}}>
      On August 6, 2023, the TISS Alums Association UP Chapter held an inaugural Alums meet in 
      Lucknow at the Golf Club, drawing over 70 Alums, including prominent figures like 
      Smt. Anamika Singh IAS and Prof. Bipin Jojo. The event featured keynote speeches, interactive sessions, 
      and productive discussions about future collaborative projects aimed at supporting local Alums and promoting 
      TISS-led initiatives. This first-ever gathering was a milestone for the UP Chapter, marking the beginning of a 
      series of impactful Alums engagements in the region.
      </p>
      <div style={styles.scrollingContainer}>
        <div style={styles.scrollingContent}>
        <img src={img28} alt="Alumni Meet 1" style={{ ...styles.image, height: '270px' }} />
        <img src={img29} alt="Alumni Meet 1" style={{ ...styles.image, height: '270px' }} />
        <img src={img30} alt="Alumni Meet 1" style={{ ...styles.image, height: '270px' }} />
        <img src={img31} alt="Alumni Meet 1" style={{ ...styles.image, height: '270px' }} />
        <img src={img32} alt="Alumni Meet 1" style={{ ...styles.image, height: '270px' }} />
        <img src={img33} alt="Alumni Meet 1" style={{ ...styles.image, height: '270px' }} />
        <img src={img34} alt="Alumni Meet 1" style={{ ...styles.image, height: '270px' }} />

        <img src={img28} alt="Alumni Meet 1" style={{ ...styles.image, height: '270px' }} />
        <img src={img29} alt="Alumni Meet 1" style={{ ...styles.image, height: '270px' }} />
       
      </div></div>

      <hr style={{ border: '1px solid #ccc', margin: '30px 0' }} />

      <h2 style={{ textAlign: 'center', fontSize: '1.5rem', marginBottom: '20px' , fontFamily: 'Inter', marginLeft : "15px"}}>Odisha</h2>
      <p style={{textAlign: 'justify', marginRight: "25px", fontSize: '1.2rem', marginBottom: '30px' , fontFamily: 'Tahoma', marginLeft : "15px"}}>
      The TISSAA Odisha Chapter hosted a successful Alums meet in Bhubaneswar on March 25, 2023, bringing together Alums to reconnect, share experiences, 
      and explore future collaborative opportunities. The event fostered meaningful exchanges of ideas and emphasized leveraging the collective strength of 
      the Alums community to drive positive change in their industries and communities. Despite some Alums being unable to attend, the gathering was a resounding 
      success, leaving attendees inspired and committed to deeper engagement with the broader TISSAA network. The chapter looks forward to organizing more impactful events in the future.
      </p>
      <div style={styles.scrollingContainer}>
        <div style={styles.scrollingContent}>
        <img src={img12} alt="Alumni Meet 1" style={{ ...styles.image, height: '270px' }} />
        <img src={img13} alt="Alumni Meet 1" style={{ ...styles.image, height: '270px' }} />
        <img src={img14} alt="Alumni Meet 1" style={{ ...styles.image, height: '270px' }} />

        <img src={img22} alt="Alumni Meet 1" style={{ ...styles.image, height: '270px' }} />
        <img src={img23} alt="Alumni Meet 1" style={{ ...styles.image, height: '270px' }} />
        <img src={img24} alt="Alumni Meet 1" style={{ ...styles.image, height: '270px' }} />
        <img src={img25} alt="Alumni Meet 1" style={{ ...styles.image, height: '270px' }} />
      </div></div>
      <hr style={{ border: '1px solid #ccc', margin: '30px 0' }} />

      <h2 style={{ textAlign: 'center', fontSize: '1.5rem', marginBottom: '20px' , fontFamily: 'Inter', marginLeft : "15px"}}>Punjab & Haryana</h2>
      <p style={{ textAlign: 'justify', marginRight: "25px",fontSize: '1.2rem', marginBottom: '30px' , fontFamily: 'Tahoma', marginLeft : "15px"}}>
      The TISSAA Chandigarh Region Chapter hosted a lively Alums gathering on September 24, 2023, at 
      the Chandigarh Club, with Dr. Rainuka Dagar leading the event. Coordinated by Gagandeep Kaur Sandher 
      and Reshma, the event featured a mix of interactive discussions and activities aimed at fostering professional 
      growth and strengthening the Alums community. The Alums exchanged insights on TISSAA’s mission, and the event 
      set the foundation for regular quarterly meetups. Special thanks were given to the organizers and attendees for 
      their contributions in making the event a success.
      </p>
      <div style={styles.scrollingContainer}>
        <div style={styles.scrollingContent}>
        <img src={img15} alt="Alumni Meet 1" style={{ ...styles.image, height: '270px' }} />
        <img src={img16} alt="Alumni Meet 1" style={{ ...styles.image, height: '270px' }} />
        <img src={img17} alt="Alumni Meet 1" style={{ ...styles.image, height: '270px' }} />

        <img src={img15} alt="Alumni Meet 1" style={{ ...styles.image, height: '270px' }} />
        <img src={img16} alt="Alumni Meet 1" style={{ ...styles.image, height: '270px' }} />
        <img src={img17} alt="Alumni Meet 1" style={{ ...styles.image, height: '270px' }} />

        <img src={img15} alt="Alumni Meet 1" style={{ ...styles.image, height: '270px' }} />
        <img src={img16} alt="Alumni Meet 1" style={{ ...styles.image, height: '270px' }} />
        <img src={img17} alt="Alumni Meet 1" style={{ ...styles.image, height: '270px' }} />
      </div></div>

      <hr style={{ border: '1px solid #ccc', margin: '30px 0' }} />

      <h2 style={{ textAlign: 'center', fontSize: '1.5rem', marginBottom: '20px' , fontFamily: 'Inter', marginLeft : "15px"}}>Karnataka</h2>
      <p style={{ textAlign: 'justify', marginRight: "25px",fontSize: '1.2rem', marginBottom: '30px' , fontFamily: 'Tahoma', marginLeft : "15px"}}>
      In Bangalore, TISSAA hosted an inspiring Alums evening where Alums like Dr. Milind D. Inamdar, 
      Dr. Anupama Shetty, and Siddhartha Dash shared their journeys, offering valuable insights into their personal 
      and professional growth. The event, which was held in a warm and engaging atmosphere, also highlighted the contributions 
      of TISS Alums to their respective fields. A special thanks was extended to Anand Lakshman for hosting this memorable evening, 
      which showcased the power of the TISS Alums network.
      </p>
      <div style={styles.scrollingContainer}>
        <div style={styles.scrollingContent}>
        <img src={img18} alt="Alumni Meet 1" style={{ ...styles.image, height: '270px' }} />
        <img src={img19} alt="Alumni Meet 1" style={{ ...styles.image, height: '270px' }} />
        <img src={img20} alt="Alumni Meet 1" style={{ ...styles.image, height: '270px' }} />
        <img src={img21} alt="Alumni Meet 1" style={{ ...styles.image, height: '270px' }} />

        <img src={img18} alt="Alumni Meet 1" style={{ ...styles.image, height: '270px' }} />
        <img src={img19} alt="Alumni Meet 1" style={{ ...styles.image, height: '270px' }} />
        <img src={img20} alt="Alumni Meet 1" style={{ ...styles.image, height: '270px' }} />

        <img src={img18} alt="Alumni Meet 1" style={{ ...styles.image, height: '270px' }} />
        <img src={img19} alt="Alumni Meet 1" style={{ ...styles.image, height: '270px' }} />
        <img src={img20} alt="Alumni Meet 1" style={{ ...styles.image, height: '270px' }} />
      </div></div>

      {/* <hr style={{ border: '1px solid #ccc', margin: '30px 0' }} />

      <h2 style={{ textAlign: 'center', fontSize: '1.5rem', marginBottom: '20px' , fontFamily: 'Inter', marginLeft : "15px"}}>Bhubaneswar</h2>
      <p style={{ fontSize: '1.2rem', marginBottom: '30px' , fontFamily: 'Tahoma', marginLeft : "15px"}}>
      The TISSAA Bhubaneswar Chapter held a successful Alums meet, bringing together Alums to share experiences, 
      exchange ideas, and explore future collaborative opportunities. Focused on collaboration and leveraging collective strength, 
      the event emphasized how Alums could work together to drive positive change in their communities and industries. Attendees left 
      the event feeling inspired and committed to meaningful engagement with the broader TISSAA network.
      </p>
      <div style={styles.scrollingContainer}>
      <div style={styles.scrollingContent}>
        <img src={img22} alt="Alumni Meet 1" style={{ ...styles.image, height: '270px' }} />
        <img src={img23} alt="Alumni Meet 1" style={{ ...styles.image, height: '270px' }} />
        <img src={img24} alt="Alumni Meet 1" style={{ ...styles.image, height: '270px' }} />
        <img src={img25} alt="Alumni Meet 1" style={{ ...styles.image, height: '270px' }} />
        
        <img src={img22} alt="Alumni Meet 1" style={{ ...styles.image, height: '270px' }} />
        <img src={img23} alt="Alumni Meet 1" style={{ ...styles.image, height: '270px' }} />
        <img src={img24} alt="Alumni Meet 1" style={{ ...styles.image, height: '270px' }} />
        <img src={img25} alt="Alumni Meet 1" style={{ ...styles.image, height: '270px' }} />
      </div></div> */}

      <hr style={{ border: '1px solid #ccc', margin: '30px 0' }} />

      <h2 style={{ textAlign: 'center', fontSize: '1.5rem', marginBottom: '20px' , fontFamily: 'Inter', marginLeft : "15px"}}>Delhi</h2>
      <p style={{ textAlign: 'justify', marginRight: "25px",fontSize: '1.2rem', marginBottom: '30px' , fontFamily: 'Tahoma', marginLeft : "15px"}}>
      The TISSAA Delhi Chapter hosted a memorable meet where TISSians came together for an enriching session filled with 
      camaraderie and insights. A highlight of the gathering was author Dr. Anjali Hazarika sharing wisdom from her book Walk the Talk. 
      The Alums, including notable figures like Christian Chandran and Amitkumar Naphade, had the privilege of receiving signed copies of 
      the book, making the event even more special. The event served as a valuable opportunity for Alums to bond and further strengthen their 
      connection with TISS.
      </p>
      <div style={styles.scrollingContainer}>
        <div style={styles.scrollingContent}>
        <img src={img26} alt="Alumni Meet 1" style={{ ...styles.image, height: '270px' }} />
        <img src={img27} alt="Alumni Meet 1" style={{ ...styles.image, height: '270px' }} />

        <img src={img26} alt="Alumni Meet 1" style={{ ...styles.image, height: '270px' }} />
        <img src={img27} alt="Alumni Meet 1" style={{ ...styles.image, height: '270px' }} />

        <img src={img26} alt="Alumni Meet 1" style={{ ...styles.image, height: '270px' }} />
        <img src={img27} alt="Alumni Meet 1" style={{ ...styles.image, height: '270px' }} />

        <img src={img26} alt="Alumni Meet 1" style={{ ...styles.image, height: '270px' }} />
        <img src={img27} alt="Alumni Meet 1" style={{ ...styles.image, height: '270px' }} />

        <img src={img26} alt="Alumni Meet 1" style={{ ...styles.image, height: '270px' }} />
      </div></div>
      <hr style={{ border: '1px solid #ccc', margin: '30px 0' }} />


      {/* Rajasthan Section (Updated for Flex-wrap only in mobile view) */}
<div className="rajasthan-container" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '30px', flexWrap: 'wrap' }}>
  <div className="rajasthan-text" style={{flex: 1,paddingLeft: '20px',textAlign: 'center',marginBottom: '20px',order: 1,}}data-aos="fade-right">
    <h2 style={{ fontSize: '1.5rem', marginBottom: '20px', fontFamily: 'Inter', marginLeft: '15px' }}>Rajasthan</h2>
    <p style={{textAlign: 'justify', marginRight: "10px", fontSize: '1.2rem', marginBottom: '30px', fontFamily: 'Tahoma', marginLeft: '10px' }}>
    On April 8, 2023, TISS alums from Rajasthan reunited in Jaipur for a heartwarming meet that fostered a sense of camaraderie and nostalgia. This memorable gathering celebrated the lifelong bonds that TISSians share, as Alums connected, shared stories, and rekindled old friendships. The event was a beautiful reminder of the impact TISS had on their lives and helped reinforce the network for future collaboration. The success of the meet paved the way for future events in Rajasthan, ensuring that Alums continue to stay connected and engaged.
    </p>
  </div>
  <div className="rajasthan-image"style={{flex: 1,order: 2,}}data-aos="fade-left">
    <img src={img11} alt="Alumni Meet 1"style={{ width: '100%', height: '420px', objectFit: 'cover', marginLeft: '10px' }} />
  </div>
</div>
{/* Mobile View Media Query */}
<style>
  {`
    @media (max-width: 768px) {
      .rajasthan-container {
        flex-direction: column-reverse !important; /* Stack image and text vertically */
        align-items: center;
      }
      .rajasthan-image img {
        width: 100% !important;
        height: auto !important;
        object-fit: cover !important;
        margin: 0 auto 20px auto; /* Center the image with spacing */
      }
      .rajasthan-text h2 {
        font-size: 1.3rem !important; /* Adjust heading size */
      }
      .rajasthan-text p {
        font-size: 1rem !important; /* Adjust text size for smaller screens */
        padding: 0 20px !important; /* Add padding for better readability */
      }
    }
  `}
</style>
      <hr style={{ border: '1px solid #ccc', margin: '30px 0' }} />

     {/* Dallas - United States Section (Updated for Flex-wrap only in mobile view) */}
     <h2 style={{ textAlign: 'center', fontSize: '1.5rem', marginBottom: '20px' , fontFamily: 'Inter', marginLeft : "15px"}}>UNITED STATES</h2>
<div className="dallas-container" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '30px', flexWrap: 'wrap' }}>
  <div className="dallas-image"style={{flex: 1,order: 1,}}data-aos="fade-right">
    <img src={img35} alt="Alumni Meet 1" style={{ width: '100%', height: '400px', objectFit: 'cover', marginLeft : "15px" }}/>
  </div>

  <div className="dallas-text" style={{flex: 1,paddingRight: '20px',order: 2,}}data-aos="fade-left">
    <h2 style={{ textAlign: 'center',fontSize: '1.5rem', marginBottom: '20px', fontFamily: 'Inter', marginLeft: "25px", marginRightt: "25px" }}>Dallas</h2>
    <p style={{textAlign: 'justify', marginRightt: "25px", fontSize: '1.2rem', marginBottom: '30px', fontFamily: 'Tahoma', marginLeft: "35px" }}>
      TISSians in Dallas, Texas, came together for a memorable reunion, where Alums like Sandhya Sridhar, Alka Nimkar, and B. S. Sridhar gathered to reminisce about their TISS experiences and reconnect. The event fostered deeper connections and emphasized the strength of the TISS community, even across borders. It was an excellent opportunity for the Alums to reflect on their shared history and look ahead to future engagements that would bring them closer together.
    </p>
  </div>
</div>

{/* Mobile View Media Query */}
<style>
  {`
    @media (max-width: 768px) {
      .dallas-container {
        flex-direction: column-reverse !important; /* Stack image and text vertically */
        align-items: center;
      }
      .dallas-image img {
        width: 100% !important;
        height: auto !important;
        object-fit: cover !important;
        margin: 0 auto 20px auto; /* Center the image with spacing */
      }
      .dallas-text h2 {
        font-size: 1.3rem !important; /* Adjust heading size */
      }
      .dallas-text p {
        font-size: 1rem !important; /* Adjust text size for smaller screens */
        padding: 0 20px !important; /* Add padding for better readability */
      }
    }
  `}
</style>


      <hr style={{ border: '1px solid #ccc', margin: '30px 0' }} />

      {/* New Jersey Section (Updated for Flex-wrap only in mobile view) */}
<div className="new-jersey-container" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '30px', flexWrap: 'wrap' }}>
  <div className="new-jersey-text" style={{flex: 1,order: 1,paddingLeft: '20px', }}data-aos="fade-right">
    <h2 style={{ textAlign: 'center', fontSize: '1.5rem', marginBottom: '20px', fontFamily: 'Inter', marginLeft : "15px" }}>New Jersey</h2>
    <p style={{ textAlign: 'justify', marginRightt: "25px",fontSize: '1.2rem', marginBottom: '30px', fontFamily: 'Tahoma', marginLeft : "15px" }}>
      The TISSAA New Jersey Chapter held its first Alums meet, which featured Alums like Neelesh Mirajkar and Dr. Milly Sil. The gathering provided a unique opportunity for TISSians to strengthen their bond and celebrate their shared legacy. The event was marked by meaningful discussions and a sense of nostalgia, with attendees expressing their eagerness to stay connected and involved in future TISSAA events.
    </p>
  </div>
  <div className="new-jersey-image" style={{flex: 1,order: 2,}}data-aos="fade-left">
    <img src={img36} alt="Alumni Meet 1" style={{ width: '100%', height: '290px', objectFit: 'cover', marginLeft : "15px" }}/>
  </div>
</div>

{/* Mobile View Media Query */}
<style>
  {`
    @media (max-width: 768px) {
      .new-jersey-container {
        flex-direction: column-reverse !important; /* Stack image and text vertically */
        align-items: center;
      }
      .new-jersey-image img {
        width: 100% !important;
        height: auto !important;
        object-fit: cover !important;
        margin: 0 auto 20px auto; /* Center the image with spacing */
      }
      .new-jersey-text h2 {
        font-size: 1.3rem !important; /* Adjust heading size */
      }
      .new-jersey-text p {
        font-size: 1rem !important; /* Adjust text size for smaller screens */
        padding: 0 20px !important; /* Add padding for better readability */
      }
    }
  `}
</style>

      <hr style={{ border: '1px solid #ccc', margin: '30px 0' }} />

      {/* Santa Clara Section (Updated for Flex-wrap only in mobile view) */}
      
<div className="santa-clara-container" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '30px', flexWrap: 'wrap' }}>
<div className="santa-clara-image" style={{flex: 1,order: 1,}} data-aos="fade-left">
    <img src={img37} alt="Alumni Meet 1" style={{ width: '100%', height: '360px', objectFit: 'cover', marginLeft : "15px" }}/>
  </div>
  <div className="santa-clara-text" style={{flex: 1,order: 2,paddingLeft: '20px',}}data-aos="fade-right">
    <h2 style={{ textAlign: 'center', fontSize: '1.5rem', marginBottom: '20px', fontFamily: 'Inter', marginLeft : "15px" }}>Santa Clara</h2>
    <p style={{ textAlign: 'justify', marginRightt: "25px",fontSize: '1.2rem', marginBottom: '30px', fontFamily: 'Tahoma', marginLeft : "15px" }}>
      TISSAA’s Santa Clara meet in California offered an opportunity for Alums to come together, share experiences, and explore ways to support TISSAA’s mission. Held at the TCS Office, the event was filled with engaging discussions and networking opportunities, ensuring Alums from the region could strengthen their ties with one another and with TISS. Future gatherings in the U.S. promise to continue building a strong community of TISS Alums worldwide.
    </p>
  </div>
  
</div>

{/* Mobile View Media Query */}
<style>
  {`
    @media (max-width: 768px) {
      .santa-clara-container {
        flex-direction: column-reverse !important; /* Stack image and text vertically */
        align-items: center;
      }
      .santa-clara-image img {
        width: 100% !important;
        height: auto !important;
        object-fit: cover !important;
        margin: 0 auto 20px auto; /* Center the image with spacing */
      }
      .santa-clara-text h2 {
        font-size: 1.3rem !important; /* Adjust heading size */
      }
      .santa-clara-text p {
        font-size: 1rem !important; /* Adjust text size for smaller screens */
        padding: 0 20px !important; /* Add padding for better readability */
      }
    }
  `}
</style>


      <hr style={{ border: '1px solid #ccc', margin: '30px 0' }} />

      {/* United States of America Section (Updated for Flex-wrap only in mobile view) */}
<div className="usa-container" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '30px', flexWrap: 'wrap' }}>
  <div className="usa-text" style={{ flex: 1, order: 1, paddingLeft: '20px', }}data-aos="fade-right">
    <h2 style={{ textAlign: 'center', fontSize: '1.5rem', marginBottom: '20px', fontFamily: 'Inter', marginLeft : "15px" }}>Madison</h2>
    <p style={{ textAlign: 'justify', marginRightt: "25px",fontSize: '1.2rem', marginBottom: '30px', fontFamily: 'Tahoma', marginLeft : "15px" }}>
      The University of Wisconsin Oshkosh, in partnership with TISSAA’s Center for Transformational Leadership, is set to offer the Global Leadership Development Program, designed for high-potential managers aiming for senior leadership roles. The program offers a unique opportunity for TISSians to advance their leadership skills while gaining valuable insights into global management practices. This collaboration between TISSAA and the University of Wisconsin Oshkosh is a testament to the global reach and impact of TISS Alums.
    </p>
  </div>
  <div className="usa-image" style={{flex: 1, order: 2,}}data-aos="fade-left" >
    <img src={img38} alt="Alumni Meet 1" style={{ width: '100%', height: '290px', objectFit: 'cover', marginLeft : "15px" }} />
  </div>
</div>

{/* Mobile View Media Query */}
<style>
  {`
    @media (max-width: 768px) {
      .usa-container {
        flex-direction: column-reverse !important; /* Stack image and text vertically */
        align-items: center;
      }
      .usa-image img {
        width: 100% !important;
        height: auto !important;
        object-fit: cover !important;
        margin: 0 auto 20px auto; /* Center the image with spacing */
      }
      .usa-text h2 {
        font-size: 1.3rem !important; /* Adjust heading size */
      }
      .usa-text p {
        font-size: 1rem !important; /* Adjust text size for smaller screens */
        padding: 0 20px !important; /* Add padding for better readability */
      }
    }
  `}
</style>


      <hr style={{ border: '1px solid #ccc', margin: '30px 0' }} />

      {/* Singapore Section (Updated for Flex-wrap only in mobile view) */}
<div className="singapore-container" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '30px', flexWrap: 'wrap', boxSizing: 'border-box' }}>
  <div className="singapore-image" style={{ flex: '1 1 50%', paddingRight: '10px', maxWidth: '100%', }} data-aos="fade-right">
    <img src={img39} alt="Alumni Meet 1" style={{ width: '100%', height: '290px', objectFit: 'cover', marginLeft: '10px', boxSizing: 'border-box',}} />
  </div>
  <div className="singapore-text" style={{ flex: '1 1 50%', paddingRight: '20px', maxWidth: '100%',}}data-aos="fade-left">
    <h2 style={{ textAlign: 'center', fontSize: '1.5rem', marginBottom: '20px', fontFamily: 'Inter', marginLeft: '0', }}>Singapore</h2>
    <p style={{ textAlign: 'justify', marginRightt: "25px",fontSize: '1.2rem', marginBottom: '30px', fontFamily: 'Tahoma', marginLeft: '25px', }}>
      The TISSAA Singapore meet brought together TISSians for a vibrant gathering filled with lively discussions and networking opportunities. Alums had the chance to reconnect and share their experiences, fostering a stronger bond within the TISS community in Singapore. The meet underscored TISSAA’s commitment to building and maintaining an active and engaged Alums network across the globe.
    </p>
  </div>
</div>

{/* Mobile View Media Query */}
<style>
  {`
    @media (max-width: 768px) {
      .singapore-container {
        flex-direction: column-reverse !important; /* Stack image and text vertically */
        align-items: center;
      }
      .singapore-image img {
        width: 100% !important;
        height: auto !important;
        object-fit: cover !important;
        margin: 0 auto 20px auto; /* Center the image with spacing */
      }
      .singapore-text h2 {
        font-size: 1.3rem !important; /* Adjust heading size */
      }
      .singapore-text p {
        font-size: 1rem !important; /* Adjust text size for smaller screens */
        padding: 0 20px !important; /* Add padding for better readability */
      }
    }
  `}
</style>


<hr style={{ border: '1px solid #ccc', margin: '30px 0' }} />

{/* Australia – Sydney Section */}
{/* Australia – Sydney Section (Updated for Flex-wrap only in mobile view) */}
<h2 style={{ textAlign: 'center', fontSize: '1.5rem', marginBottom: '20px' , fontFamily: 'Inter', marginLeft : "15px"}}>AUSTRALIA</h2>
<div className="australia-sydney-container" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '30px', flexWrap: 'wrap', boxSizing: 'border-box' }}>
  <div className="australia-sydney-text" style={{ flex: '1 1 50%',paddingLeft: '20px', maxWidth: '100%',}}data-aos="fade-right" >
    <h2 style={{ textAlign: 'center', fontSize: '1.5rem', marginBottom: '20px', fontFamily: 'Inter', marginLeft: '10px',}} > Sydney </h2>
    <p style={{textAlign: 'justify', marginRightt: "25px", fontSize: '1.2rem', marginBottom: '30px', fontFamily: 'Tahoma', marginLeft: '0px',}}>
      The TISSAA Sydney meet brought together Alums like Shiva Shrestha, Shailesh Dangle, Indrani Chall, and Jayita Das to reminisce about their TISS days while engaging in insightful discussions. The gathering not only rekindled old memories but also helped Alums explore potential ways to collaborate and contribute to the TISSAA community. The Sydney meet proved to be another successful chapter in TISSAA’s global Alums engagement strategy.
    </p>
  </div>
  <div className="australia-sydney-image" style={{flex: '1 1 50%',maxWidth: '100%',}}data-aos="fade-left">
    <img src={img40} alt="Alumni Meet 1" style={{ width: '100%', height: '330px', objectFit: 'cover', marginLeft: '10px', boxSizing: 'border-box', }}/>
  </div>
</div>

{/* Mobile View Media Query */}
<style>
  {`
    @media (max-width: 768px) {
      .australia-sydney-container {
        flex-direction: column-reverse !important; /* Stack image and text vertically */
        align-items: center;
      }
      .australia-sydney-image img {
        width: 100% !important;
        height: auto !important;
        object-fit: cover !important;
        margin: 0 auto 20px auto; /* Center the image with spacing */
      }
      .australia-sydney-text h2 {
        font-size: 1.3rem !important; /* Adjust heading size */
      }
      .australia-sydney-text p {
        font-size: 1rem !important; /* Adjust text size for smaller screens */
        padding: 0 20px !important; /* Add padding for better readability */
      }
    }
  `}
</style>
<Footer />
    </div>
  );
};


const styles = {
  scrollingContainer: {
    marginBottom: '40px',
    justifyItems: 'center',
    overflow: 'hidden',
    position: 'relative',
    width: '100%',
    height: '300px',
    padding: '10px 0',
    boxSizing: 'border-box', // Ensure padding is included in the width and height calculation
  },
  scrollingContent: {
    display: 'flex',
    animation: 'scroll 15s linear infinite',
    gap: '15px',
  },
  image: {
    width: '100%',
    height: 'auto',
    borderRadius: '8px',
    objectFit: 'cover',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
    transition: 'transform 0.3s ease, box-shadow 0.3s ease',
  },
  imageHover: {
    transform: 'scale(1.05)',
    boxShadow: '0 6px 16px rgba(0, 0, 0, 0.15)',
  },
  '@global': {
    html: {
      margin: 0, // Remove margin on html
      padding: 0, // Remove padding on html
      boxSizing: 'border-box', // Set box-sizing globally
    },
    body: {
      margin: 0, // Remove margin on body
      padding: 0, // Remove padding on body
      boxSizing: 'border-box', // Ensure padding is included in width calculation
    },
    '*': {
      boxSizing: 'border-box', // Apply box-sizing: border-box globally to all elements
      overflowX :'hidden',
    },
  },
  // Media Query for Tablets (max-width: 768px)
  '@media (max-width: 768px)': {
    div: {
      flexDirection: 'column-reverse',
      alignItems: 'center',
      margin: '0', // Ensure no margin
      padding: '0', // Ensure no padding
    },
    section: {
      flexDirection: 'column-reverse',
    },
    image: {
      width: '100%',
      height: 'auto',
      objectFit: 'cover',
      marginLeft: '0',
    },
    text: {
      paddingLeft: '10px',
      paddingRight: '10px',
    },
    flexWrap: 'wrap', // Add flex-wrap for smaller screens
    scrollingContainer: {
      overflowX: 'hidden', // Ensure no horizontal scrolling
      padding: '0', // Remove padding if causing issue
    },
  },

  // Mobile-specific Styles (max-width: 480px)
  '@media (max-width: 480px)': {
    div: {
      display: 'flex',
      flexDirection: 'column-reverse', /* Stack content vertically */
      alignItems: 'center', /* Center align for smaller screens */
      margin: '0', /* Remove left and right margin */
      padding: '0', /* Remove padding */
    },
    contentText: {
      paddingLeft: '10px', /* Adjust padding for text */
      paddingRight: '10px', /* Adjust padding for text */
      fontSize: '1rem', /* Adjust font size for mobile */
      textAlign: 'center', /* Center-align text */
      marginBottom: '15px', /* Add margin to separate text from image */
    },
    image: {
      width: '100%', /* Ensure image takes full width */
      height: '250px', /* Adjust image height for mobile */
      objectFit: 'cover', /* Maintain image aspect ratio */
      marginTop: '10px', /* Add space between text and image */
    },
    scrollingContainer: {
      paddingRight: '0', /* Ensure no padding on right */
      marginRight: '0', /* Remove right margin */
    },
  },
};
const stylesString = `
@keyframes scroll {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-100%);
  }
}
html, body {
  margin: 0;
  padding: 0;
  overflow-x: hidden;
  width: 100%;
}
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}
body {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}
header, footer {
  width: 100%;
  overflow-x: hidden;
}
.scrollingContainer {
  width: 100%;
  overflow-x: hidden;
  position: relative;
  margin: 0 auto;
}
.scrollingContent {
  display: flex;
  animation: scroll 15s linear infinite;
  gap: 15px;
  overflow-x: hidden;
}
.scrollingContent img {
  max-width: 100%;
  height: auto;
}
@media (max-width: 768px) {
  h2 {
    font-size: 1.2rem !important;
  }
  p {
    font-size: 1rem !important;
    margin-bottom: 15px !important;
  }
  
}`;

const GlobalStyles = () => (
  <style dangerouslySetInnerHTML={{ __html: stylesString }} />
);

export default () => (
  <>
    <GlobalStyles />
    <Alumnimeet />
  </>
);
